import React, { useRef, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";

function ReCaptcha({ onCaptchaChange, error }) {
  const recaptchaRef = useRef(null);
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";

  useEffect(() => {
    // Reset CAPTCHA when error occurs
    if (error && recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  }, [error]);

  const handleChange = (token) => {
    if (token) {
      onCaptchaChange({
        recaptcha_token: token
      });
    } else {
      onCaptchaChange(null);
    }
  };

  const handleExpired = () => {
    onCaptchaChange(null);
  };

  if (!siteKey) {
    console.warn("REACT_APP_RECAPTCHA_SITE_KEY is not set");
    return (
      <div style={{
        padding: 12,
        background: "#fee2e2",
        border: "1px solid #fecaca",
        borderRadius: 8,
        color: "#dc2626",
        fontSize: 12
      }}>
        reCAPTCHA site key not configured. Please set REACT_APP_RECAPTCHA_SITE_KEY in environment variables.
      </div>
    );
  }

  return (
    <div style={{ marginBottom: 16 }}>
      <label style={{
        display: "block",
        color: "#475569",
        fontSize: 12,
        marginBottom: 6,
        fontWeight: "500"
      }}>
        Security Verification *
      </label>
      
      <div style={{
        display: "flex",
        justifyContent: "center",
        marginBottom: 8
      }}>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={siteKey}
          onChange={handleChange}
          onExpired={handleExpired}
          theme="light"
        />
      </div>
      
      {error && (
        <div style={{
          color: "#dc2626",
          fontSize: 12,
          marginTop: 6,
          textAlign: "center",
          padding: 8,
          backgroundColor: "#fef2f2",
          borderRadius: 6,
          border: "1px solid #fecaca"
        }}>
          {error}
        </div>
      )}
    </div>
  );
}

export default ReCaptcha;

